document.documentElement.classList.add('js');

(function () {
  var selectedPackage = { name: '', price: 0 };
  var packageButtons = document.querySelectorAll('.quote-package');
  var addonInputs = document.querySelectorAll('.quote-addon');
  var packageName = document.getElementById('quote-package-name');
  var quoteItems = document.getElementById('quote-items');
  var quoteTotal = document.getElementById('quote-total');

  if (!packageButtons.length || !quoteTotal) return;

  function money(amount) {
    return '$' + amount.toLocaleString();
  }

  function updateQuote() {
    var total = selectedPackage.price;
    var items = [];

    addonInputs.forEach(function (input) {
      if (input.checked) {
        var name = input.getAttribute('data-name');
        var price = Number(input.getAttribute('data-price') || 0);
        total += price;
        items.push(name + ' +' + money(price));
      }
    });

    packageName.textContent = selectedPackage.name ? selectedPackage.name + ' - ' + money(selectedPackage.price) : 'Select a package';
    quoteItems.innerHTML = '';

    if (items.length) {
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        quoteItems.appendChild(li);
      });
    } else {
      var li = document.createElement('li');
      li.textContent = 'No add-ons selected yet.';
      quoteItems.appendChild(li);
    }

    quoteTotal.textContent = money(total);
  }

  packageButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      packageButtons.forEach(function (btn) { btn.classList.remove('is-selected'); });
      button.classList.add('is-selected');
      selectedPackage.name = button.getAttribute('data-package');
      selectedPackage.price = Number(button.getAttribute('data-price') || 0);
      updateQuote();
      document.getElementById('addons').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  addonInputs.forEach(function (input) {
    input.addEventListener('change', updateQuote);
  });

  updateQuote();
})();
